<template>
    <div v-if="gwpEligible && gwpEligible.length > 0">
        <div v-for="(gwpRule, index) in gwpEligible" :key="index" class="oaps-sproduct__eligible-product">
            <div class="oaps-sproduct__label" v-if="gwpRule?.rule_title">
                <span
                @click="showPopup"
                @mouseenter="onHoverEnter"
                @mouseleave="onHoverLeave"
                >{{ displayTextPrice(gwpRule.rule_title) }}</span>
                <div class="oaps-sproduct__modal-overlay" v-if="gwpRule.product_data.length > 0 && isPopup">
                    <div class="oaps-sproduct__popup">
                        <div class="oaps-sproduct__products">
                            <div class="oaps-sproduct__product" v-for="gwpProduct in gwpRule.product_data">
                                <img class="oaps-sproduct__thumbnail" :src="`${baseUrl}api/wp-content/uploads/${ gwpProduct.thumbnail_lazy || gwpProduct.thumbnail}`" :data-orignal_src="`${baseUrl}api/wp-content/uploads/${gwpProduct.thumbnail}`" :alt="gwpProduct.alt ?? ''">
                                <div class="oaps-sproduct__detail">
                                    <h4>{{ gwpProduct.name }}</h4>
                                    <span class="oaps-sproduct__price"><span>Free</span><span>U.P.<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">{{ wooStore.currency.symbol }}</span>{{ displayPrice(gwpProduct.price) }}</bdi></span></span></span>
                                </div>
                            </div>
                        </div>
                        <a @click="closePopup" class="oaps-sproduct__close-btn">Done</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { displayPrice, displayTextPrice } from "~/utils/displayPrice";
    const wooStore = useWooStore();
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    const props = defineProps(["data"]);
    interface IGWPProductData{
        name: string,
        price: string,
        thumbnail: string | null;
        thumbnail_lazy: string | null;
        alt: string;
    }
    interface IGWPEligible{
        rule_title: string,
        product_data: IGWPProductData[];
    }
    const gwpEligible = ref<IGWPEligible[]>();
    gwpEligible.value = props.data;

    const isPopup = ref(false);

    const closePopup = () => {
        isPopup.value = false;
        document.body.style.overflowY = 'auto';
    };

    const showPopup = () => {
        if (window.innerWidth <= 768) {
            isPopup.value = true;
            document.body.style.overflowY = 'hidden';
        }
    };

    const onHoverEnter = () => {
        if (window.innerWidth > 768) {
            isPopup.value = true;
        }
    };

    const onHoverLeave = () => {
        if (window.innerWidth > 768) {
            isPopup.value = false;
        }
    };
    onMounted(() => {
        altLazyIO();
    })
</script>